export default async function factoryReset() {
  // @ts-ignore
  window.location = window.location.pathname
}
